export const shareFacebook = (route) => {
  window.open(`http://www.facebook.com/sharer.php?u=${route}`);
};
